// extracted by mini-css-extract-plugin
export default {"loader":"LoadingScreen_loader__nj6W1"};